import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PopulationQuery } from '@fgb/core';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-auction-detail-page',
  templateUrl: './auction-detail-page.component.html',
  styleUrls: ['./auction-detail-page.component.scss'],
})
export class AuctionDetailPageComponent implements OnInit {
  constructor(private route: ActivatedRoute, private populationQuery: PopulationQuery) {}
  id: number;
  isCorporate: boolean;
  populations = Populations;

  ngOnInit() {
    this.id = +(this.route.snapshot.paramMap.get('id') || 0);
    this.isCorporate = this.populationQuery.userInPopulation([this.populations.Hospitality]);
  }
}
